/**
 * Which calendar builder /calendar shows: v2, everywhere. A customer with an
 * unfinished v1 draft stays on v1 (v1 drafts do not convert) unless v2 is
 * asked for with ?builder=v2. ?builder=v1 still opens the old builder, for
 * support and as a way back.
 */
export function chooseCalendarBuilder(opts: {
  /** NEXT_PUBLIC_SENTRY_ENVIRONMENT; no longer decides, kept for callers. */
  env: string | undefined;
  search: URLSearchParams;
  hasV1Draft: boolean;
}): 'v1' | 'v2' {
  const asked = opts.search.get('builder');
  if (asked === 'v2') return 'v2';
  if (asked === 'v1') return 'v1';
  if (opts.hasV1Draft) return 'v1';
  return 'v2';
}
